module.exports = __webpack_public_path__ + "static/media/amithyst_logo.8e23afde.png";